import React, { useEffect, useRef } from 'react';

const PaystackModal = ({ 
  isOpen, 
  onClose, 
  transactionData, 
  onSuccess, 
  onError 
}) => {
  const isOpeningRef = useRef(false);

  useEffect(() => {
    if (!isOpen || !transactionData) return;

    // Prevent multiple simultaneous openings
    if (isOpeningRef.current) return;
    isOpeningRef.current = true;

    const initializePaystack = () => {
      if (!window.PaystackPop) return;

      const handler = window.PaystackPop.setup({
        key: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
        email: transactionData.email,
        amount: transactionData.amount,
        ref: transactionData.reference,
        currency: 'NGN',
        channels: ['card', 'bank', 'ussd', 'qr', 'mobile_money'],
        callback: (response) => {
          onSuccess(response.reference);
          onClose();
        },
        onClose: () => {
          onError?.('Payment closed');
          onClose();
        },
      });

      handler.openIframe();
    };

    if (!window.PaystackPop) {
      const script = document.createElement('script');
      script.src = 'https://js.paystack.co/v1/inline.js';
      script.async = true;
      script.onload = initializePaystack;
      script.onerror = () => {
        onError?.('Failed to load Paystack script');
        onClose();
      };
      document.body.appendChild(script);
    } else {
      initializePaystack();
    }

    return () => {
      isOpeningRef.current = false;
    };
  }, [isOpen, transactionData, onClose, onSuccess, onError]);

  // Disable background scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-neutral-800 rounded-2xl shadow-xl p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-200">
            Complete Payment
          </h3>
          <button
            onClick={onClose}
            className="text-neutral-500 hover:text-neutral-700 dark:text-neutral-400"
          >
            ✕
          </button>
        </div>

        <p className="text-sm text-neutral-600 dark:text-neutral-400">
          Secure payment via Paystack. Your card details are never stored.
        </p>

        <div id="paystack-embed-container" className="mt-4"></div>
      </div>
    </div>
  );
};

export default PaystackModal;




// import React, { useEffect } from 'react';

// const PaystackModal = ({ isOpen, onClose, transactionData, onSuccess, onError }) => {

//     useEffect(() => {
//         if (!isOpen || !transactionData || !window.PaystackPop) return;

//         const handler = window.PaystackPop.setup({
//             key: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
//             email: transactionData.email,
//             amount: transactionData.amount,
//             ref: transactionData.reference,
//             currency: 'NGN',
//             channels: ['card', 'bank', 'ussd', 'qr', 'mobile_money'],
//             callback: (response) => {
//                 onSuccess(response.reference);
//                 onClose();
//             },
//             onClose: () => {
//                 onError?.('Payment closed');
//                 onClose();
//             }
//         });

//         handler.openIframe();
//     }, [isOpen, transactionData]);

//     useEffect(() => {
//         if (isOpen) {
//             document.body.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = '';
//         }
//         return () => {
//             document.body.style.overflow = '';
//         };
//     }, [isOpen]);

//     if (!isOpen) return null;

//     return (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//             <div className="bg-white dark:bg-neutral-800 rounded-lg p-6 w-full max-w-md">
//                 <div className="flex justify-between items-center mb-4">
//                     <h3 className="text-lg font-medium">Complete Payment</h3>
//                     <button
//                         onClick={onClose}
//                         className="text-neutral-500 hover:text-neutral-700 dark:text-neutral-400"
//                     >
//                         ✕
//                     </button>
//                 </div>
//                 <p className="text-sm text-neutral-600 dark:text-neutral-400">
//                     Secure payment via Paystack. Your card details are never stored.
//                 </p>
//                 <div id="paystack-embed-container" className="mt-4"></div>
//             </div>
//         </div>
//     );
// };

// export default PaystackModal;